import {
    // ActivatedRouteSnapshot,
    // RouterStateSnapshot,
    Params,
  } from '@angular/router';

export interface RouterStateUrl {
    url: string;
    queryParams: Params;
    params: Params;
  }

